import { GamePart } from "../../contracts";
import { translate } from "../../helpers";
// TODO: reduce complexity
export const buildScoresData = (event, scoreKeys, config) => {
    const scoresData = scoreKeys.reduce((acc, val, index, arr) => {
        if (!event.scores[val.team1Key] && !event.scores[val.team2Key]) {
            return acc;
        }
        const header = val.translatable ? translate(config.dict, val.header) : val.header;
        let team1Score = event.scores[val.team1Key];
        let team2Score = event.scores[val.team2Key];
        shouldAddDefault(val, event, arr, index) && (team1Score = team2Score = "-");
        return fillData(acc, header, team1Score, team2Score);
    }, { team1Scores: [], team2Scores: [], headers: [] });
    swapTeamScores(event.isTeamSwap, scoresData);
    return scoresData;
};
const shouldAddDefault = (scoreKeys, event, arr, currentScoreIndex) => {
    if (!scoreKeys.gamePart) {
        return false;
    }
    if (event.scores[scoreKeys.team1Key] !== "0" || event.scores[scoreKeys.team2Key] !== "0") {
        return false;
    }
    return shouldAddDefaultByGamePart(arr, event.liveGameState.gamePart, currentScoreIndex);
};
const shouldAddDefaultByGamePart = (arr, gamePart, currentScoreIndex) => {
    if (!gamePart) {
        return true;
    }
    if (gamePart === GamePart.Finished) {
        return false;
    }
    return arr.findIndex(x => x.gamePart === gamePart.replace("BreakAfter", "")) < currentScoreIndex;
};
// TODO: Change structure to components, so not to use 3 different array, but only one!!!
const fillData = (acc, header, team1Score, team2Score) => {
    acc.headers.push(header);
    acc.team1Scores.push(team1Score);
    acc.team2Scores.push(team2Score);
    return acc;
};
const swapTeamScores = (isTeamSwap, scoresData) => {
    isTeamSwap && ([scoresData.team1Scores, scoresData.team2Scores] = [scoresData.team2Scores, scoresData.team1Scores]);
};
//# sourceMappingURL=buildScoresData.js.map